<template>
    <b-modal id="billing_delete" ref="billing_delete"
             :title="'Delete Bill ' + billing.data.attributes.code + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('billing_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteBilling">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "BillingDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'billing',
    ],

    methods: {
        deleteBilling() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteBilling', this.billing.billing_id)
                    .then(() => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-billing');

                            this.$notify('error filled', 'Success!', 'Deleted the bill!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('billing_delete');
                        }, 2000);
                    })
                    .catch(errors => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },
    },
}
</script>

<style scoped>

</style>
